<template>
  <div class="advertising">
    <div style="width:100%;height:100%;">
      <iframe :src="url" frameborder="0" id="iframe" width="100%" height="90%" style="top: 10px;" scrolling="no"></iframe>
    </div>
  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
  import {
    mySessionStorage
  } from '@/utils/storage.js'
  export default {
    name: "appeal",
    data() {
      return {
        isShowTestDiv: false,
        url: "", //展示图片
      };
    },
    methods: {},
    created() {},
    mounted() {
      this.url = this.$route.query.url;
    },
  };
</script>

<style scoped>
  .advertising {
    background-color: #F0F0F0;
    height: 100%;
    width: 100%;
    padding-top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/advertising.vue